<template>
  <div class="managingPeople hp100 bbox " v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
        <el-col>
          <div class="flex align-center  header-search-box">
            <el-form class="myForm" :inline="true">
              <!-- <el-form-item label="桌台编号:"><el-input clearable placeholder="请输入桌台号" style="width:126px"></el-input> </el-form-item> -->
              <!-- <el-form-item label="桌台名称:"><el-input clearable v-model="queryInfo.condition.tableName"
               placeholder="请输入桌台名称" style="width:140px"></el-input></el-form-item> -->
            <el-form-item label="桌台区域:">
              <el-input clearable style="width:150px" placeholder="请输入桌台区域"
               v-model="queryInfo.condition.areaName"></el-input>
                 <!-- <el-select value-key="id" clearable :popper-append-to-body="false"
                 style="width:90px" v-model="tableSelect" placeholder="请选择">
                       <el-option
                       v-for="item,index in tableOption" :key="index"
                 :label="item.areaName"
                 :value="item">
                    </el-option>
                 </el-select> -->
            </el-form-item>
              <el-form-item  label="桌台可用餐人数:">
              <el-input placeholder="用餐人数" clearable v-model="queryInfo.condition.containNum" style="width:100px"></el-input></el-form-item>
              <el-form-item label="桌台类型:">
                <el-input placeholder="桌台类型" clearable v-model="queryInfo.condition.tableType"
              style="width:100px"></el-input></el-form-item>
              <el-button @click="search">
                查询 <i v-if="btnLoading" class="el-icon-loading"></i>
                </el-button>
            </el-form>
          </div>
       
        </el-col>
           <el-button @click="dialogFormVisible = true" style="transform: translateY(-2px);">新增桌台</el-button>
      <!-- 用户列表区域 -->
      <!-- <div :style="{ height: height + 'px' }" style=" margin-top: 20px;"> -->
        <!-- <el-scrollbar style="height: 100%; width: 100%"> -->
          <el-row style="width: 100%;">
            <el-table
              :data="tableData"
               v-loading="tableLoading"
             element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.8)"
              border
              fit
              height="62vh"
              highlight-current-row
              style="width: 100%"
              @sort-change="sortChange"
            >
              <!-- <el-table-column label="桌台编号" align="center" >
                <template slot-scope="scope">
                  <span>{{ scope.row.areaCode }}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="桌台序号" align="center" prop="桌台">
                <template slot-scope="scope">
                  <span>{{ scope.row.tableName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="桌台区域"
                align="center"
                prop="areaName"
              >
              </el-table-column>
              <el-table-column label="桌台类型" align="center" prop="tableType">
              </el-table-column>
              <el-table-column
                label="桌台可用餐人数"
                align="center"
                prop="containNum"
              >
              </el-table-column>

              <el-table-column
                label="桌台状态"
                align="center"
                prop="桌台状态"
              >
                <template slot-scope="scope">
                  <span style="color:#6CA75B;font-weight:500" v-if="scope.row.status==1">可用</span>
                  <span style="color:#E34B1B;font-weight:500" v-else>不可用</span>
                </template>
              </el-table-column>
              <el-table-column
                label="预约数量限制"
                align="center"
                prop="预约数量限制"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.bookLimitCount }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                align="center"
                class-name="small-padding fixed-width"
              >
                <template slot-scope="scope">
                  <span  @click="edit(scope.row.id)"
                  style="margin-right:8px;color:#F59A23;font-weight:500;cursor:pointer">编辑</span>
                <!-- <el-popconfirm
  confirm-button-text='确定'
  cancel-button-text='取消'
  icon="el-icon-info"
  icon-color="red"
  title="确定删除吗？"
  @confirm="del(scope.row.id)"
  @onConfirm="del(scope.row.id)"
> -->
<span slot="reference" @click="del(scope.row.id)"  style="color:#DB2F41;font-weight:500;cursor:pointer">删除</span>
<!-- </el-popconfirm>  -->
                </template>
              </el-table-column>
            </el-table> 
                    <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
            </el-row
        >
        <!-- </el-scrollbar> -->
      <!-- </div> -->
      <!-- <div class="footerBox">
   
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div> -->
    </el-card>
    <el-dialog title="新增桌台" width="572px" :visible.sync="dialogFormVisible">
  <el-form :model="form" :inline="true" label-width="116px">
    <el-form-item label="桌台区域:" >
      <el-input placeholder="请输入桌台区域名" style="width:140px" v-model="form.areaName"></el-input>
    </el-form-item>
        <el-form-item label="桌台序号:" >
      <el-input placeholder="桌台序号(例A、B.)" style="width:140px" 
      v-model="form.tableName"></el-input>
    </el-form-item>
        <el-form-item label="桌台类型:" >
      <el-input class="noPadding"
       placeholder="桌台类型(例3-5人桌)" style="width:140px" v-model="form.tableType"></el-input>
    </el-form-item>
           <el-form-item label="桌台状态:" >
     <el-select v-model="form.status" style="width:140px">
      <el-option label="可用" value="1"></el-option>
      <el-option label="不可用" value="0"></el-option>
     </el-select>
    </el-form-item>
            <el-form-item label="桌台可用餐人数:" >
      <el-input placeholder="最多可容纳人数" style="width:140px" 
      v-model="form.containNum"></el-input>
    </el-form-item>

       <el-form-item label="预约数量限制:" >
      <el-input class="noPadding"  placeholder="请输入预约数量限制" 
      style="width:140px" v-model="form.bookLimitCount"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button class="diaBtn cacel"  @click="dialogFormVisible = false">取 消</el-button>
    <el-button  class="diaBtn btn"   @click="saveNewTable">确 定</el-button>
  </div>
</el-dialog>
    <el-dialog title="修改桌台" width="572px" :visible.sync="updateFormVisible">
  <el-form :model="form" :inline="true" label-width="116px">
    <el-form-item label="桌台区域:" >
      <el-input placeholder="请输入桌台区域名" style="width:140px" v-model="editForm.areaName"></el-input>
    </el-form-item>
        <el-form-item label="桌台序号:" >
      <el-input placeholder="桌台序号(例A、B.)" style="width:140px" 
      v-model="editForm.tableName"></el-input>
    </el-form-item>
        <el-form-item label="桌台类型:" >
      <el-input class="noPadding"
       placeholder="桌台类型(例3-5人桌)" style="width:140px" v-model="editForm.tableType"></el-input>
    </el-form-item>
           <el-form-item label="桌台状态:" >
     <el-select v-model="editForm.status" style="width:140px">
      <el-option label="可用" value="1"></el-option>
      <el-option label="不可用" value="0"></el-option>
     </el-select>
    </el-form-item>
            <el-form-item label="桌台可用餐人数:" >
      <el-input placeholder="最多可容纳人数" style="width:140px" 
      v-model="editForm.containNum"></el-input>
    </el-form-item>

       <el-form-item label="预约数量限制:" >
      <el-input class="noPadding"  placeholder="请输入预约数量限制" 
      style="width:140px" v-model="editForm.bookLimitCount"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button class="diaBtn cacel"  @click="updateFormVisible = false">取 消</el-button>
    <el-button  class="diaBtn btn"   @click="updateTable">确 定</el-button>
  </div>
</el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableLoading:true,
      btnLoading:false,
      dialogFormVisible:false,
      updateFormVisible:false,
      editForm:{
        tableName:'',//桌台名称
        areaName:"",//桌台区域
        tableType:"",//桌台类型
        containNum:'',//桌台可用餐人数
        status:'',//桌台状态
        bookLimitCount:'',//预约人数限制
        merchantCode:localStorage.getItem('merchantCode'),
        merchantName:localStorage.getItem('merchantName')
      },
      form:{
        // tableCode:'',//桌台编号
        tableName:'',//桌台名称
        areaName:"",//桌台区域
        tableType:"",//桌台类型
        containNum:'',//桌台可用餐人数
        status:'',//桌台状态
        bookLimitCount:'',//预约人数限制
        merchantCode:localStorage.getItem('merchantCode'),
        merchantName:localStorage.getItem('merchantName')
      },
      tableSelect:null,
      tableOption:[],
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          merchantCode: localStorage.getItem('merchantCode'),
          areaName:"",
          tableType:"",
          containNum:""
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: ""
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false
    };
  },
  created() {
    this.getListData();
    // this.tableSelectList()
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    // 新增桌台
    saveNewTable(){
      console.log(this.form)
        this.dialogFormVisible=false
      this.$http.post('/merchantLineCondition/save',this.form).then(res=>{
        console.log(res)
        if(res.data.code==200){
          this.$message({type:'success',message:'新增成功'})
              this.getListData();
             this.tableSelectList()
        }else{
          this.$message.error(res.data.message)
        }
      
      })
    },
    edit(id){
      this.updateFormVisible=true
      this.$http.post('/merchantLineCondition/queryOne',{id}).then(res=>{
        console.log(res,'----')
        this.editForm=res.data.data
      })
    },
    updateTable(){
      this.updateFormVisible=false
      this.$http.post('/merchantLineCondition/save',this.editForm).then(res=>{
        console.log(res)
        if(res.data.code==200){
          this.$message({type:'success',message:'修改成功'})
              this.getListData();
             this.tableSelectList()
        }else{
          this.$message.error(res.data.message)
        }
      
      })
    },
        //桌台下拉
    tableSelectList(){
        this.$http.post('/merchantLineCondition/querySelectTableList',{merchantCode:localStorage.getItem('merchantCode')}).then(res=>{
            this.tableOption=res.data.data
        })
    },
    //条件查询
    search() {
      this.btnLoading=true
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/merchantLineCondition/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize
        }
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantLineCondition/delete", { id: id })
          .then(function(response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      this.tableLoading=true
      var that = this;
      that.$http
        .post("/merchantLineCondition/list", that.queryInfo)
        .then(function(response) {
          that.tableLoading=false
          that.btnLoading=false
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    }
  }
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    // height: calc(100vh - 114px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
/deep/.el-input__inner,.el-button{
  line-height: 30px !important;
  height: 30px !important;
}
/deep/ .el-button{
  transform: translateY(2px);
  background-color: #F59A23;
  color: #fff;
  margin-left: 8px;
}
/deep/ .el-button:focus{
  border-color: transparent;
}
/deep/ input:focusr{
       border-color:#F59A23 ;
}
/deep/ .el-select .el-input__inner:focus{
       border-color:#F59A23 ;
}
/deep/ .el-select-dropdown__item.selected{
       color:#F59A23 ;
}
/deep/ .el-input__inner:focus{
    border-color: #F59A23;
}
/deep/ .diaBtn.cacel{
  background-color: #fff;
  color: #ADAFB8;
}
/deep/ .noPadding>input{
  padding-right: 0;
}
/deep/ .diaBtn{
  line-height: 32px !important;
  height: 32px !important;
  border-radius: 6px;
}
/deep/ .myForm>div{
  margin-right: 16px;
}
</style>
